"use strict"

import React from "react"
import { FormattedMessage } from "react-intl"

export function ConfirmEditedResource(props) {
  return (
    <>
      <div>
        <span className={`fa fa-check-square-o`} style={{ marginRight: "20px" }} />
        <FormattedMessage
          id={`${props.modal_title_id}`}
          description={`Manage ${props.resource_name} Modal Title`}
        />
      </div>
      <br />
      {props.table_title && props.table_title}
      <DisplayTable table_info={props.table_info} table={props.resource_name} data={props.data} />
    </>
  )
}

export function AddSourceTags(props) {
  const table_info = [
    { header_id: "general.observation.type", key: "observation_type" },
    { header_id: "general.tag", key: "tag" },
    { header_id: "general.units", key: "units" },
  ]
  return (
    <>
      <h6>
        <FormattedMessage
          id={"sourceregistration.register.new.source.tags"}
          description={"Register New Source Tags"}
        />
        : {props.source.name}
      </h6>
      <DisplayTable table_info={table_info} table={"Add SourceTags"} data={props.data} />
    </>
  )
}

const DisplayTable = (props) => {
  const { table_info, table } = props
  return (
    <table className={"table table-sm tbl_lanzatable"}>
      <thead>
        <tr>
          {table_info.map((col, idx) => (
            <th key={`${col}_${idx}`} className={"text-center"}>
              <h6>
                <FormattedMessage
                  id={col["header_id"]}
                  description={`${table} Column Header (${col["key"]})`}
                />
              </h6>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {props.data.map((resource, idx) => (
          <tr key={`new_${table}_${idx}`}>
            {table_info.map((col, i) => {
              let content
              if (col["key"] !== "active" && col["key"] !== "status") {
                content = resource[col["key"]]
              } else if (col["key"] === "active") {
                const glyph = resource["active"] ? "check-circle-o" : "times-circle-o"
                content = <span className={`fa fa-${glyph} text-success`} />
              } else {
                let glyph = "check-circle-o"
                let text_color = "text-success"
                if (resource["status"] === "Inspecting") {
                  glyph = "refresh"
                  text_color = "text-info"
                } else if (resource["status"] === "Error") {
                  glyph = "times-circle-o"
                  text_color = "text-danger"
                } else if (resource["status"] === "Deleting") {
                  glyph = "trash"
                  text_color = "text-danger"
                }
                content = <span className={`fa fa-${glyph} ${text_color}`} />
              }

              return (
                <td className={"text-center"} key={`row${idx}_col${i}`}>
                  <>{content}</>
                </td>
              )
            })}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export function UnregisterDCSTable(props) {
  const { data } = props
  return (
    <>
      <div>
        <h5 className={"text-center"}>
          <FormattedMessage id={props.title} />?
        </h5>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <h6>
          <FormattedMessage id={"general.name"} />:
        </h6>
        &nbsp;&nbsp;
        <p style={{ margin: "0px" }}>{data.name}</p>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <h6>
          <FormattedMessage id={"general.description"} />:
        </h6>
        &nbsp;&nbsp;
        <p style={{ margin: "0px" }}>{data.description}</p>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <h6>
          <FormattedMessage id={"general.source"} />:
        </h6>
        &nbsp;&nbsp;
        <p style={{ margin: "0px" }}>{data.source.name}</p>
      </div>
    </>
  )
}
